export default {
  SaleInvoice: 1,
  SaleInvoiceReplace: 3,
  SaleInvoiceAdjustment: 5,
  SaleInvoiceCancel: 2,
  SaleInvoiceReplaced: 7,
  SaleInvoiceAdjustmented: 8,
};
